import { useWindowDimensions } from 'react-native';
import { useEffect, useState } from 'react';

export const useIsLargeScreen = () => {
  const { width } = useWindowDimensions();
  const [isLarge, setIsLarge] = useState(() => width >= 768);

  useEffect(() => {
    if (width === 0) return;
    setIsLarge(width >= 768);
  }, [width]);

  return isLarge;
};